/**
 * Represents a callback function
 */
type Callback = () => void;

/**
 * Utility function to display a full-screen div until a user interacts with the page.
 * Once the user clicks on the div, it disappears and the specified callback function is executed.
 * @param {Callback} onUserInteraction - The callback function to execute after user interaction.
 */
export function waitForUserInteraction(onUserInteraction: Callback) {
  // Create the cover div
  const interactionCover = document.createElement('div');
  interactionCover.style.position = 'fixed';
  interactionCover.style.top = '0';
  interactionCover.style.left = '0';
  interactionCover.style.width = '100vw';
  interactionCover.style.height = '100vh';
  interactionCover.style.zIndex = '1000';
  interactionCover.style.display = 'flex';
  interactionCover.style.justifyContent = 'center';
  interactionCover.style.alignItems = 'center';

  // Listen for the click event
  interactionCover.addEventListener('mousedown', function () {
    // Remove the cover when clicked
    document.body.removeChild(interactionCover);
    // Execute the callback function
    onUserInteraction();
  });

  // Listen for the click event
  interactionCover.addEventListener('touchstart', function () {
    // Remove the cover when clicked
    document.body.removeChild(interactionCover);
    // Execute the callback function
    onUserInteraction();
  });

  // Append the newly created div to the DOM body
  document.body.appendChild(interactionCover);
}
